// import logo from './logo.svg';
import './App.css';
import MovieList from './components/MoviesList';
import AddMovie from './components/AddMovie';
import Login from './components/Login';
import Nav from './components/Nav';
import Register from './pages/Register';
import { Route, Link, Switch, Redirect } from "react-router-dom";
import PrivateRoute from './Hooks/PrivateRoute';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMovies } from './store/actions/moviesActions';

function App() {
  const url = 'http://localhost:3000/movies'
  const { movies, moviesLoading, moviesError } = useSelector(state => state.moviesReducer)
  const dispatch = useDispatch()
  
  useEffect(() => {
    dispatch(getMovies(url))
  }, [])

  return (
    <>
    <Nav/>
    <Switch>
      <PrivateRoute exact path="/">
        <MovieList movies={movies} loading={moviesLoading}/>
      </PrivateRoute>
      <PrivateRoute path="/addmovie">
        <AddMovie />
      </PrivateRoute>
      <Route path="/login">
        <Login/>
      </Route>
      <Route path="/register">
        <Register/>
      </Route>
      <PrivateRoute path="/movie/:id">
        <AddMovie/>
      </PrivateRoute>

      <Route path="*">
        <h1>Page Not Found</h1>
      </Route>
    </Switch>

    </>
  );
}

export default App;
